/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseCHClosedIcon16Light } from './ArrowCollapseCHClosedIcon16Light';
import { ArrowCollapseCHClosedIcon16Regular } from './ArrowCollapseCHClosedIcon16Regular';
import { ArrowCollapseCHClosedIcon16Solid } from './ArrowCollapseCHClosedIcon16Solid';
import { ArrowCollapseCHClosedIcon20Light } from './ArrowCollapseCHClosedIcon20Light';
import { ArrowCollapseCHClosedIcon20Regular } from './ArrowCollapseCHClosedIcon20Regular';
import { ArrowCollapseCHClosedIcon20Solid } from './ArrowCollapseCHClosedIcon20Solid';
import { ArrowCollapseCHClosedIcon24Regular } from './ArrowCollapseCHClosedIcon24Regular';
import { ArrowCollapseCHClosedIcon24Solid } from './ArrowCollapseCHClosedIcon24Solid';
import { ArrowCollapseCHClosedIcon32Regular } from './ArrowCollapseCHClosedIcon32Regular';
import { ArrowCollapseCHClosedIcon64Regular } from './ArrowCollapseCHClosedIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseCHClosedIcon16Light,
        regular: ArrowCollapseCHClosedIcon16Regular,
        solid: ArrowCollapseCHClosedIcon16Solid,
    },
    20: {
        light: ArrowCollapseCHClosedIcon20Light,
        regular: ArrowCollapseCHClosedIcon20Regular,
        solid: ArrowCollapseCHClosedIcon20Solid,
    },
    24: {
        regular: ArrowCollapseCHClosedIcon24Regular,
        solid: ArrowCollapseCHClosedIcon24Solid,
    },
    32: {
        regular: ArrowCollapseCHClosedIcon32Regular,
    },
    64: {
        regular: ArrowCollapseCHClosedIcon64Regular,
    },
};
export var ArrowCollapseCHClosedIcon = forwardRef('ArrowCollapseCHClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
